module.exports = __webpack_public_path__ + "img/w3_circle_left_black.8e1671e2.png";